"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _CurrencyFormatter = _interopRequireDefault(require("../../common/Formatters/CurrencyFormatter"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.number-input {\n  width: 100%;\n  margin-bottom: 1.5rem; }\n  .number-input .bx--label {\n    color: #4c4c4c; }\n  .number-input .tooltip {\n    color: #a8a8a8; }\n  .number-input .bx--number input[type='number'] {\n    font-family: Helvetica;\n    padding-right: 1rem; }\n    .number-input .bx--number input[type='number']::placeholder {\n      color: #a8a8a8; }\n  .number-input .bx--number input[data-invalid='true'] {\n    padding-right: 2.5rem; }\n  .number-input .bx--number__invalid {\n    right: 1rem; }\n  .number-input .bx--number__controls {\n    display: none; }\n";
  const fileName = "NumberInput_NumberInput";
  const element = document.querySelector("style[data-sass-component='NumberInput_NumberInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const NumberInput = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const [hasBeenUpdated, setHasBeenUpdated] = (0, _react.useState)(props.value || props.value === 0);
  const [formattedWithCurrency, setFormattedWithCurrency] = (0, _react.useState)(_CurrencyFormatter.default.formatAlternate(props.value, props.formatting));
  const [currentVal, setCurrentVal] = (0, _react.useState)(props.value);
  const numbersOnly = e => {
    var dots = [110, 190];

    // Allow only one dot.
    if (e.target.value.indexOf('.') !== -1 && dots.indexOf(e.keyCode) !== -1) {
      e.preventDefault();
    }

    // Reject e key
    if (e.keyCode === 69) {
      e.preventDefault();
    }
  };
  const controlNumberChange = value => {
    setHasBeenUpdated(true);
    let rawNumber = value.toString().replace(/[^0-9\.]/g, '');
    setFormattedWithCurrency(false);
    props.onChange(null, rawNumber);
    setCurrentVal(rawNumber);
  };

  // Add and remove string elements while updating numeric value
  const formatting = function (val) {
    let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (val === null) {
      return;
    }
    // We want people to be able to clear out the fields and trigger the parent to show unfinished state again.
    if (val === '') {
      props.onChange(null, null);
      return;
    }
    controlNumberChange(val);
    setFormattedWithCurrency(_CurrencyFormatter.default.formatAlternate(parseFloat(val), action).trim());
  };
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  (0, _react.useEffect)(() => {
    if (props.hardReset) {
      setHasBeenUpdated(true);
      setCurrentVal(0);
      setFormattedWithCurrency(_CurrencyFormatter.default.formatAlternate(0, props.formatting).trim());
    }
  });
  if (props.allowNegatives) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "number-input-with-formatting"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "number-input"
    }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.NumberInput, {
      id: props.id,
      autoComplete: props.autoComplete,
      label: customLabel,
      onChange: e => props.onChange(null, e.target.value),
      value: props.value,
      placeholder: props.placeholder,
      helperText: props.helperText,
      invalid: Boolean(props.invalidText),
      invalidText: props.invalidText,
      autoFocus: props.autoFocus,
      disabled: props.disabled
    })));
  }
  if (props.formatting) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "number-input-with-formatting"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "number-input"
    }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextInput, {
      ref: ref,
      id: props.id,
      autoComplete: props.autoComplete,
      labelText: customLabel,
      onChange: e => controlNumberChange(e.target.value),
      value: !hasBeenUpdated ? '' : formattedWithCurrency || currentVal,
      placeholder: props.placeholder,
      helperText: props.helperText,
      invalid: Boolean(props.invalidText),
      invalidText: props.invalidText,
      autoFocus: props.autoFocus,
      onBlur: e => formatting(currentVal, props.formatting),
      onFocus: e => formatting(currentVal, false),
      onKeyDown: e => numbersOnly(e),
      disabled: props.disabled
    })));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "number-input"
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.NumberInput, {
    id: props.id,
    label: customLabel,
    onChange: e => props.onChange(e, e.target.value),
    allowEmpty: true,
    value: props.value,
    placeholder: props.placeholder,
    helperText: props.helperText,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    onKeyDown: e => numbersOnly(e),
    autoFocus: props.autoFocus,
    disabled: props.disabled
  }));
});
NumberInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  helperText: _propTypes.default.string,
  invalidText: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  type: _propTypes.default.string,
  formatting: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  hardReset: _propTypes.default.bool
};
NumberInput.defaultProps = {
  type: 'NumberInput' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = NumberInput;